import { MolsonFileUploader } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'

export const CustomFileUploader = molsonStyled(MolsonFileUploader)(
  ({ hideFileSize = false }: { hideFileSize?: boolean }) => {
    return {
      '& .dx-state-invisible': {
        display: 'block !important'
      },
      ...(hideFileSize && {
        '& .dx-fileuploader-file-size': {
          display: 'none'
        }
      })
    }
  }
)
